import { List, Map, fromJS } from 'immutable'

const initFilterData = fromJS({
	page: 1,
	sort: '',
	search: '',
	per_page: 20,
	test_type: '',
	job_role: '',
	job_level: []
})

export function assessmentPagination(state = Map({}), action) {
	switch(action.type) {
		case 'ASSESSMENTS_FETCH_PAGINATION_SUCCESS':
			return Map(action.pagination)
		default:
			return state
	}
}

export function assessmentFilterData(state = initFilterData, action) {
	switch(action.type) {
		case 'ASSESSMENTS_ADD_FILTER_PAGE_NUMBER_SUCCESS':
			return state.set('page', action.page)
		case 'ASSESSMENTS_ADD_FILTER_SORT_SUCCESS':
			return state.set('sort', action.sort)
		case 'ASSESSMENTS_ADD_FILTER_SEARCH_SUCCESS':
			return state.set('search', action.search)
		case 'ASSESSMENTS_ADD_FILTER_TEST_TYPE_SUCCESS':
			return state.set('test_type', action.test_type)
		case 'ASSESSMENTS_ADD_FILTER_JOB_ROLE_SUCCESS':
			return state.set('job_role', action.job_role)
		case 'ASSESSMENTS_ADD_FILTER_JOB_LEVEL_SUCCESS':
			return state.set('job_level', action.job_level)
		case 'ASSESSMENTS_CLEAR_FILTER_DATA_SUCCESS':
			return fromJS({
				page: 1,
				sort: '',
				search: '',
				per_page: 20,
				test_type: '',
				job_role: '',
				job_level: []
			})
		default:
			return state
	}
}

export function assessments(state = List([]), action) {
	switch(action.type) {
		case 'ASSESSMENTS_FETCH_DATA_SUCCESS':
			return fromJS(action.assessments)
		default:
			return state
	}
}

export function assessment(state = Map({}), action) {
	switch(action.type) {
		case 'ASSESSMENTS_GET_DETAIL_SUCCESS':
			return fromJS(action.assessment)
		default:
			return state
	}
}